<template>
  <div class="l-learn-finger-read l-learn-content-container" v-if="element">
    <div v-if="!started" class="finger-read__mask">
        <p class="finger-read__mask-text" v-if="countDown > 0">{{ countDown }}</p>
        <button v-else class="finger-read__play__btn" @click="handleStart">
          <img src="./images/play.png">
        </button>
    </div>
    <img src="./images/logo.png" alt="" class="finger-read__logo">
    <img src="./images/boy.png" alt="" class="finger-read__boy">
    <div ref="fingerReadContainer" class="finger-read__container">
        <!-- <audio ref="audio"></audio> -->
        <button v-if="started" class="action-btn" @click="playing = !playing">{{ playing ? '暂停' : '继续' }}</button>
        <div ref="fingerReadContent"
            class="finger-read__content__text"
            @mousedown="handleSwipeStart"
            @mouseup="handleSwipeEnd"
            @mousemove="handleMouseMove"
            @touchstart="handleSwipeStart"
            @touchend="handleSwipeEnd"
            @touchmove="handleTouchMove">
            <div class="item-wrap" 
                v-for="(item, lineIndex) in lrcArr"
                :key="item.time">
                <img v-if="lineIndex === currentLineIndex" class="finger-read__current-label" src="./images/arrow.png">
                <p class="finger-read__content__text__item"
                    :class="{
                        'active': lineIndex === currentLineIndex,
                        'readed': lineIndex <= currentLineIndex,
                    }"
                    :data-line-index="lineIndex">
                    <span 
                        v-for="(word, index) in item.sliceLrc" 
                        :key="index" 
                        :data-index="index"
                    >{{ word }}</span>
                </p>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import laudio from '@/utils/laudio'
import UPModel from '@/models/imgup'
import elementTypes from '../../minxin/elementTypes'

const up = new UPModel()
const { mapGetters, mapActions } = createNamespacedHelpers('course')

// 歌词的时间匹配正则
const timeReg = /\[(\d{2}):(\d{2}).(\d{2,3})]/
export default {
  name: 'l-learn-point-read',
  mixins: [elementTypes],
  props: {
    autoplay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      laudio: null,
      started: false,
      countDown: 0,
      playing: false,
      isDrawing: false,
      // 已经读过的单词的索引
      currentLineIndex: 0,
      readIndexList: {},
    }
  },
  computed: {
    ...mapGetters(['element']),
    audioLrc() {
      return this.element.attrs.audioLrc
    },
    lrcArr() {
      if (!this.audioLrc) return [];
      return this.audioLrc.split('\n').map(item => {
          const time = timeReg.exec(item);
          if (time) {
              const minute = time[1];
              const second = time[2];
              const millisecond = time[3].length === 3 ? time[3] * 1 : time[3] * 10;
              return {
                  time: minute * 60 * 1000 + second * 1000 + millisecond,
                  lrc: item.replace(timeReg, '').trim()
              }
          }
          return {
              time: 0,
              lrc: item
          }
      }).map((item) => ({
          ...item,
          sliceLrc: item.lrc.split(' ')
      }))
    } 
  },
  watch: {
    'element.ELEMENT_TYPE'(val) {
      if (!val) return
      this.initSourceUrl()
    },
  },
  methods: {
    ...mapActions(['STUDY_RESULT']),
    initSourceUrl() {
      const paths = [this.element.attrs.audioUrl]

      up.resource({ paths: paths })
        .then((res) => {
          this.initAudio(res.data[0])
        })
        .catch((err) => {
          console.error(err)
        })
    },
    async initAudio(src) {
      if (src) {
        this.laudio = laudio({
          src,
        })
      }

      if (this.laudio) {
        this.initEvent()
      }
    },
    initEvent() {
      // 监听播放事件
      this.laudio.addEventListener('play', () => {
        this.playing = true
      })
      this.laudio.addEventListener("timeupdate", () => {
        const newTime = this.laudio.currentTime * 1000;
        this.calcCurrentLineIndex(newTime + 500)
      });

      // 播放完成
      this.laudio.addEventListener('ended', () => {
        this.playing = false
        this.ended()
      })
    },
    scrollToView() {
      // this.$nextTick 确保 DOM 元素已更新
      this.$nextTick(() => {
        const contentContainer = this.$refs.fingerReadContainer
        const contentContent = this.$refs.fingerReadContent
        const currentLine = contentContent.children[this.currentLineIndex]
        if (currentLine) {
          const containerHeight = contentContainer.clientHeight
          const containerScrollHeight = contentContainer.scrollHeight
          const containerScrollTop = contentContainer.scrollTop
          const currentLineOffsetTop = currentLine.offsetTop
          const currentLineHeight = currentLine.clientHeight

          // 确定活动行是否在容器中间以下的位置 
          if (currentLineOffsetTop + currentLineHeight > containerScrollTop + (containerHeight / 2)) {
            // 关键部分: 考虑已经滚动到底部的情况
            if (containerScrollTop + containerHeight < containerScrollHeight) {
              const scrollTo = currentLineOffsetTop + (currentLineHeight / 2) - (containerHeight / 2)
              // 使用滚动动画而不是瞬间跳转
              contentContainer.scrollTo({
                top: scrollTo,
                behavior: 'smooth'
              })
            }
          }
        }
      })
    },
    // 计算音频当前播放到第几行
    calcCurrentLineIndex(newTime) {
      const index = this.lrcArr.findIndex((item, index) => {
          return newTime >= item.time && newTime <= (this.lrcArr[index + 1]?.time || this.laudio.duration * 1000)
      }); 
      this.currentLineIndex = index;
      this.scrollToView()
    },
    // 计算正确率
    calcAccuracy() {
      const total = this.lrcArr.reduce((prev, item) => {
          return prev + item.sliceLrc.length;
      }, 0);
      const readTotal = Object.values(this.readIndexList).reduce((prev, item) => {
          return prev + item.length;
      }, 0);
      console.log('正确率', `${(readTotal / total * 100).toFixed(2)}%`);
      return (readTotal / total * 100).toFixed(2);
    },
    // 结束
    async ended() {
      this.started = false;
      const accuracy = this.calcAccuracy();
        // 先上传作答成绩
      await this.STUDY_RESULT({
        elementId: this.$route.query.dataId,
        postData: {
          suggestedScore: accuracy,
        },
      })
      this.$emit('submit')
    },


    handleStart() {
        this.countDown = 3;
        // 倒计时3秒后开始
        const timer = setInterval(() => {
            this.countDown--;
            if (this.countDown === 0) {
                clearInterval(timer);
                this.started = true;
                this.laudio.play()
            }
        }, 1000);
    },
    handleSwipeStart() {
      this.isDrawing = true;
    },
    handleSwipeEnd() {
      this.isDrawing = false;
    },
    handleSwipe(el) {
        if (!this.isDrawing || !this.playing) return;
        if (el.tagName.toLowerCase() !== 'span') return;
        const elParentNodeLineIndex = Number(el.parentNode.dataset.lineIndex);
        if (elParentNodeLineIndex !== this.currentLineIndex) return;

        el.style.color = 'red';
        this.readIndexList[elParentNodeLineIndex] = this.readIndexList[elParentNodeLineIndex] || [];
        if (!this.readIndexList[elParentNodeLineIndex].includes(Number(el.dataset.index))) {
            this.readIndexList[elParentNodeLineIndex].push(Number(el.dataset.index));
        }
    },
    handleMouseMove(e) {
      this.handleSwipe(e.target);
    },
    handleTouchMove(e) {
      const touch = e.touches[0];
      const el = document.elementFromPoint(touch.clientX, touch.clientY);
      this.handleSwipe(el);
    },
  },
  mounted() {
    if (this.element) {
      this.initSourceUrl()
    }
  },
  destroyed() {
    if (this.laudio) {
      this.laudio.pause()
    }
  },
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>
<style scoped>
.finger-read__mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(200, 200, 200, 0.5);
    border-radius: 40px;
    color: #fff;
    font-size: 20px;
}
.finger-read__mask-text {
    font-size: 80px;
    font-weight: bold;
    color: #ea9c2c;
}
.finger-read__play__btn {
    width: 120px;
    height: 100px;
    cursor: pointer;
}
.finger-read__play__btn img {
    width: 100%;
    height: 100%;
}

.finger-read__logo {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 180px;
    height: 80px;
}
.finger-read__boy {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 160px;
    height: 258px;
}

.finger-read__container {
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px 180px 20px 120px;
  overflow: auto;
}
.action-btn {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 10;
}
.finger-read__content__text {
    font-size: 36px;
    font-weight: bold;
    color: #7C7AA1;
    user-select: none;
}
.item-wrap {
    /* margin-bottom: 20px; */
}
.finger-read__current-label {
    float: left;
    width: 62px;
    height: 48px;
    padding-top: 16px;
    margin-left: -82px;
    margin-right: 20px;
}
.finger-read__content__text__item {
    flex: 1;
    margin: 0;
    text-align: left;
}
.finger-read__content__text__item.active {
    background: url(./images/text-bg.png) center/100% 100% no-repeat;
}
.finger-read__content__text__item.readed {
    color: #1F094C;
}
.finger-read__content__text span {
    display: inline-block;
    padding: 16px 8px 52px;
    transition: color 0.3s;
}
</style>
